<template>
    <div class="setpwd">
        <p style="font-size: 20px;color: #000">{{$t('setPayPwd')}}</p>
        <div>
            <p>{{$t('setPwdTits')}}</p>
            <van-password-input
                :value="value"
                :gutter="10"
                :length="6"
                :focused="showKeyboard"
                @focus="showKeyboard = true"
            />
            <van-number-keyboard
                v-model="value"
                :show="showKeyboard"
                @blur="showKeyboard = false"
            />
            <van-button size="large" round type="danger" @click="nextHandle" style="margin-top: 20px;">{{$t('nextStep')}}</van-button>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { ref } from 'vue';
import {mapGetters, mapActions} from 'vuex';
import { Toast } from 'vant';

export default {
  name: 'Finish',
  data(){
    return{
        storage: localStorage.getItem('storage') ? JSON.parse(localStorage.getItem('storage')) : [],
        role: localStorage.getItem('role') ? localStorage.getItem('role') : '',
        showKeyboard: true,
        value: ''
    }
  },
  methods: {
    ...mapGetters(['']),
    nextHandle(){
      // let val = parseInt((this.value + '').substring(0, 6))
      // console.log(this.value.substring(0,6))
      if(this.value.length > 5){
        this.$router.push({
          path: '/setpwdstep2',
          query: {
            oldPwd: this.$route.query.oldPwd,
            eCode: this.$route.query.eCode,
            pwd: this.$md5(this.value.substring(0,6)),
            from: this.$route.query.from
          }
        })
      }
    }
  },
  computed:{
  },
  mounted(){
      // this.$watch('value', val => {
      //     if(val.length > 5){
      //       this.$router.push({
      //         path: '/setpwdstep2',
      //         query: {
      //           oldPwd: this.$route.query.oldPwd,
      //           pwd: this.$md5(this.value)
      //         }
      //       })
      //     }
      // })
  },
  beforeDestroy(){
  }
}
</script>

<style lang="scss">
.setpwd{
  margin: 10px;
  img{
    display: block;
    width: 20%;
    margin: 0 auto;
  }
  p{
    text-align: center;
    font-size: 10px;
    color: #9e9e9e;
    margin-top: 20px;
  }
  .van-button{
    height: 30px;
    margin: 0 auto;
    position: relative;
    display: block;
    line-height: 30px;
    text-align: center;
    width: 40%;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .login_tips{
      text-align: center;
      font-size: 14px;
      margin: 10px 0;
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-swipe-item{
    img{
      width: 100%;
    }
  }
  .van-password-input__security{
        li{
            background-color: #e9e9e9;
            border-radius: 6px;
            &.van-password-input__item--focus{
                background-color: #fff;
                border: 1px solid #e60012;
            }
        }
  }
  .van-button--large{
    width: calc(100% - 20px);
    height: 30px;
    font-size: 14px;
    border-radius: 15px;
  }
  .van-password-input__security{
      height: 45px;
  }
  .van-overlay{
    z-index: 101;
  }
}
</style>
